/**
 * Landing nueva (vault 346, L0): páginas públicas que se retiraron del sitio. Cada dirección vieja lleva
 * al inicio con `<Navigate replace>` (no hay SSR ni reglas de `serve`, así que no hay 301 reales).
 *
 * · `/go-to-market`, `/gtm/resumen` y `/roadmap`: exponían estrategia comercial y planes por cliente.
 * · `/blog`, `/case-studies` y `/careers`: autores, casos y vacantes inventados (D20).
 * · `/soluciones/*`: métricas por rubro sin fuente (D25).
 *
 * Sus archivos se borraron: una página que sólo se esconde del menú igual viaja en el paquete JS.
 */
export const RUTAS_PUBLICAS_RETIRADAS = [
  '/go-to-market',
  '/gtm/resumen',
  '/roadmap',
  '/blog',
  '/blog/:slug',
  '/case-studies',
  '/case-studies/:slug',
  '/careers',
  '/soluciones',
  '/soluciones/:slug',
] as const;

/** Las carpetas de `src/features/` que se borraron con esas páginas (un test vigila que no vuelvan). */
export const FEATURES_RETIRADAS = [
  'go-to-market',
  'roadmap',
  'blog',
  'case-studies',
  'careers',
  'solutions',
] as const;
